import * as React from 'react';

import { cn } from '../../lib/utils';

const TypographyH2 = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/heading-has-content
  <h2
    ref={ref}
    className={cn('scroll-m-20 text-display-xl font-regular', className)}
    {...props}
  />
));
TypographyH2.displayName = 'TypographyH2';

export { TypographyH2 };
